import React from 'react';
import PropTypes from 'prop-types';

import {Commands as ModuleCommands} from 'views/module';

const SlashCommands = (props) => {
  const {clientBackend, clientData, clientRn} = props;

  const slashCommandProps = React.useMemo(() => {
    const getRelationshipContact = (relationship, type) => {
      return relationship?.contacts?.find((contact) => contact.type === type)?.detail || '';
    };
    const relationships = Object.values(clientData.relationships ?? {}).sort((a, b) => {
      return a.priority - b.priority;
    });
    const defaultRelationship = relationships.find((relationship) => {
      return Number(relationship.priority) === 1;
    }) || relationships[0] || null;

    const [firstName, ...lastNameParts] = clientData.clientName.split(' ');

    return {
      communicationTarget: {
        defaultRelationship,
        relationships,
        getRelationshipEmail: (relationship) => getRelationshipContact(relationship, 'Email'),
        getRelationshipSms: (relationship) => getRelationshipContact(relationship, 'Phone'),
        sendEmail: async (emailData, targetRelationshipRn, onSuccess, onError=()=>undefined) => {
          const relationshipRn = targetRelationshipRn || defaultRelationship?.relationshipRn;

          if (!relationshipRn) {
            onError();
            return null;
          }

          return clientBackend.messages.sendEmail(relationshipRn, emailData, onSuccess, onError);
        },
        sendSms: async (smsData, requester, targetRelationshipRn, onSuccess, onError=()=>undefined) => {
          const relationshipRn = targetRelationshipRn || defaultRelationship?.relationshipRn;

          if (!relationshipRn) {
            onError();
            return null;
          }

          return clientBackend.messages.sendSms(
              relationshipRn,
              smsData.message,
              requester?.email,
              smsData.from,
              onSuccess,
              onError,
          );
        },
        updateCareplan: async (careplan, progressOptions={}) => {
          return clientBackend.careplan.updateCareplan(careplan, progressOptions);
        },
      },
      resources: [
        {type: 'CLIENT', rn: clientRn, firstName, lastName: lastNameParts.join(' ')},
      ],
    };
  }, [clientBackend, clientData, clientRn]);

  return (
    <ModuleCommands
      {...slashCommandProps}
    />
  );
};

SlashCommands.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
  clientRn: PropTypes.string.isRequired,
};

export default React.memo(SlashCommands);
